export const TYPES = {
  FIREBASE_AUTH_STATUS: "auth/FIREBASE_AUTH_STATUS",
};
